<label>{{ to.label }}:</label>
<strong
  ><b> {{ to.text }}</b></strong
>
